var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.46202 0.423962C5.68212 -0.021939 6.31796 -0.0219382 6.53807 0.423963L7.92057 3.22477C8.0079 3.40168 8.17661 3.52436 8.37182 3.55289L11.4644 4.00492C11.9564 4.07683 12.1525 4.68153 11.7963 5.02843L9.55945 7.20712C9.41792 7.34497 9.35333 7.54365 9.38672 7.73836L9.9145 10.8156C9.99857 11.3057 9.48404 11.6795 9.04386 11.448L6.27931 9.99418C6.10448 9.90224 5.8956 9.90224 5.72077 9.99418L2.95622 11.448C2.51604 11.6795 2.00151 11.3057 2.08558 10.8156L2.61336 7.73836C2.64676 7.54365 2.58216 7.34497 2.44063 7.20712L0.203781 5.02843C-0.152375 4.68153 0.0436954 4.07683 0.535644 4.00492L3.62826 3.55289C3.82347 3.52436 3.99218 3.40168 4.07951 3.22477L5.46202 0.423962Z",
    fill: "#FCB25B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.18d81d4c9a9581ba4e56f4138d608e88.svg";
export { ForwardRef as ReactComponent };